import { render } from "./simpleKeyboard.vue?vue&type=template&id=cbeb0a76"
import script from "./simpleKeyboard.vue?vue&type=script&lang=js"
export * from "./simpleKeyboard.vue?vue&type=script&lang=js"

import "./simpleKeyboard.vue?vue&type=style&index=0&id=cbeb0a76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__